module.exports = __webpack_public_path__ + "img/digital-membership-24-25.34fb15a9.png";